import styled from "styled-components";
import ShowFlightInfoButton from "./ShowFlightInfoButton.styled";

interface MobileFlightInfoProps {
  isFlightShown: boolean;
}

const MobileFlightInfo = styled.div<MobileFlightInfoProps>`
  display: none;

  ${ShowFlightInfoButton} {
    margin-bottom: ${({ isFlightShown }) => (isFlightShown ? "24px" : "0")};
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: block;
  }
`;

export default MobileFlightInfo;
